import { render, staticRenderFns } from "./ChannelListView.vue?vue&type=template&id=c9083ae4&scoped=true&"
import script from "./ChannelListView.vue?vue&type=script&lang=js&"
export * from "./ChannelListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9083ae4",
  null
  
)

export default component.exports